// utils/exportExcel.ts
import * as XLSX from "xlsx";

export function exportToExcel(data, filename = "data.xlsx") {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Create binary excel file and trigger download
    const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
    });

    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const exportContentsToExcel = (token, label) => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_BASE_URL}export-import?token=${token}&type=${label}`;
    link.download = "exported_contents.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
